<ng-container *ngIf="(inputConfig$ | async) as inputConfig">
  <div class="naziv-pojavnog-oblika-row">
    <div class="left">
      <ntap-dynamic [compId]="prefiksNazivaCompId" [inputParam]="inputParam"></ntap-dynamic>
    </div>
    <div class="right">
      <input type="text" [placeholder]="placeholder" pInputText [formControl]="oznakaFormControl" [readonly]="(oznakaDisabled$ | async) ?? true" [ngClass]="{ readonly: oznakaDisabled$ | async}">
    </div>
  </div>
</ng-container>
